import { createSelector } from 'reselect';
import api from './api';

const stateFacilitySelector = (state) => state.facility;

export const selector = createSelector([stateFacilitySelector], (facility) => {
  return { ...facility };
});

const FACILITY_FETCH_ALL_REQUEST = 'FACILITY_FETCH_ALL_REQUEST';
const FACILITY_FETCH_ALL_SUCCESS = 'FACILITY_FETCH_ALL_SUCCESS';
const FACILITY_FETCH_ALL_FAILURE = 'FACILITY_FETCH_ALL_FAILURE';

const FACILITY__CREATE_REQUEST = 'FACILITY__CREATE_REQUEST';
const FACILITY__CREATE_SUCCESS = 'FACILITY__CREATE_SUCCESS';
const FACILITY__CREATE_FAILURE = 'FACILITY__CREATE_FAILURE';

const FACILITY__UPDATE_REQUEST = 'FACILITY__UPDATE_REQUEST';
const FACILITY__UPDATE_SUCCESS = 'FACILITY__UPDATE_SUCCESS';
const FACILITY__UPDATE_FAILURE = 'FACILITY__UPDATE_FAILURE';

const FACILITY__DELETE_REQUEST = 'FACILITY__DELETE_REQUEST';
const FACILITY__DELETE_SUCCESS = 'FACILITY__DELETE_SUCCESS';
const FACILITY__DELETE_FAILURE = 'FACILITY__DELETE_FAILURE';

const initialState = {
    facilities: {},
};

export const actionCreators = {
  getFacilities: () =>
    api({
      types: [FACILITY_FETCH_ALL_REQUEST, FACILITY_FETCH_ALL_SUCCESS, FACILITY_FETCH_ALL_FAILURE],
      uri: '/api/facility',
      config: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
      sendJwtBearer: true,
    }),
  createFacility: (facility) =>
    api({
      types: [FACILITY__CREATE_REQUEST, FACILITY__CREATE_SUCCESS, FACILITY__CREATE_FAILURE],
      uri: '/api/facility',
      config: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(facility),
      },
      payload: facility,
      sendJwtBearer: true,
    }),
  deleteFacility: (facility) =>
    api({
      types: [FACILITY__DELETE_REQUEST, FACILITY__DELETE_SUCCESS, FACILITY__DELETE_FAILURE],
      uri: '/api/facility',
      config: {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(facility),
      },
      payload: facility,
      sendJwtBearer: true,
    }),
  updateFacility: (facility) => 
    api({
      types: [FACILITY__UPDATE_REQUEST, FACILITY__UPDATE_SUCCESS, FACILITY__UPDATE_FAILURE],
      uri: '/api/facility',
      config: {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(facility),
      },
      payload: facility,
      sendJwtBearer: true,
    }),
};

export const reducer = (state = initialState, action) => {
    switch(action.type) {
      case FACILITY__UPDATE_SUCCESS:
      case FACILITY__CREATE_SUCCESS:
        return {...state, facilities: {...state.facilities, [action.response.id]:{...action.response} }};
      case FACILITY_FETCH_ALL_SUCCESS:
        return {...state, facilities: {...state.facilities,  ...action.response.reduce((obj, item) => {
          obj[item.id] = item
          return obj
        }, {})}}
      case FACILITY__DELETE_SUCCESS: {
          const newState = {...state};
          delete newState.facilities[action.payload.id]
          return {...newState}
        }
      default: 
        return {...state};
    }
};